import React, { useCallback, useEffect, useState } from "react";
import "./Header.css";
import { toggleicon, Search2, BellIcon } from "../../assets/Exportimageicon";
import MyProfile from "../profile/MyProfile";
import Notifications from "../notifications/Notifications";
import { apiGet } from "../../Services/Services";
import { ENDPOINTS } from "../../Services/Endpoints";
import {
  DefaultProfileImage,
  getProfileImageSrc,
} from "../../utils/profileImage";

const Header = ({ onToggle }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [profileImage, setProfileImage] = useState("");

  const fetchHeaderProfile = useCallback(async () => {
    try {
      const response = await apiGet(ENDPOINTS.profile.getDetail);
      setProfileImage(response?.data?.profileImage ?? "");
    } catch (error) {
      console.error("Error fetching header profile image:", error);
    }
  }, []);

  useEffect(() => {
    fetchHeaderProfile();
  }, [fetchHeaderProfile]);

  const handleProfileUpdate = (image = "") => {
    setProfileImage(image || "");
  };

  return (
    <header className="top-header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onToggle}>
          <img src={toggleicon} alt="toggle" />
        </button>
      </div>

      <div className="header-right">
        {/* <div className={`search-wrapper ${searchOpen ? "open" : ""}`}>
          <input type="text" placeholder="Search..." />
        </div> */}

        <button className="search-mobile-btn" onClick={() => setSearchOpen(!searchOpen)}>
          <img src={Search2} alt="search" />
        </button>

        <button
          type="button"
          className="notification-btn"
          onClick={() => {
            setShowProfile(false);
            setShowNotifications(true);
          }}
          aria-label="Open notifications"
        >
          <img src={BellIcon} alt="notification bell" />
        </button>

        <button
          type="button"
          className="profile-trigger"
          onClick={() => {
            setShowNotifications(false);
            setShowProfile(true);
          }}
          aria-label="Open profile"
        >
          <img
            src={getProfileImageSrc(profileImage)}
            alt="profile"
            className="profile-img"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = DefaultProfileImage;
            }}
          />
        </button>
      </div>

      <MyProfile
        open={showProfile}
        onClose={() => setShowProfile(false)}
        onProfileUpdate={handleProfileUpdate}
      />
      <Notifications
        open={showNotifications}
        onClose={() => setShowNotifications(false)}
      />
    </header>
  );
};

export default Header;